import React from 'react';

const SchedulesPDF: React.FC = () => {
    return <div>Schedules PDF</div>;
};

export default SchedulesPDF;
